import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["id", "__typename", "streetNumber"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useUser } from '~/composables/_next/useUser';
import { useCart } from '~/composables/useCart';
import { useTrpc } from '~/composables/_next/useTrpc';
import { useDeliveryLocations } from '~/composables/useDeliveryLocations';
import { useCoupon } from '~/composables/_next/cart/useCoupon';
import { useFeatureFlagTalonOne } from '~/composables/_next/useFeatureFlagTalonOne';
import findCurrentAddressId from '@/helpers/Checkout/findCurrentAddressId';
import { isProductDiscontinued, isProductOutOfStock } from '@/utils/ProductAvailability';
import { getAllUnmatchedCoupons } from '@/utils/ProductDiscount';
var isMalformedCustom = ref(false);
var fixedCurrentShippingAddressAfterSelectingPickupPoint = ref(null);
var useCheckout = function useCheckout() {
  var router = useRouter();
  var context = useNuxt2App();
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;
  var app = context.app,
    config = context.$vsf.$ct.config,
    locale = context.i18n.locale;
  var _useUser = useUser(),
    isAuthenticated = _useUser.isAuthenticated;
  var _useCart = useCart(),
    cart = _useCart.cart,
    updateCartLocaleAndCountry = _useCart.updateCartLocaleAndCountry,
    removeItem = _useCart.removeItem,
    recalculateCart = _useCart.recalculateCart,
    setDeliveryType = _useCart.setDeliveryType,
    updateCartShippingAddress = _useCart.updateShippingAddress,
    updateCartBillingAddress = _useCart.updateBillingAddress;
  var _useCoupon = useCoupon(),
    removeCartCoupon = _useCoupon.removeCartCoupon,
    legacyRemoveCartCoupon = _useCoupon.legacyRemoveCartCoupon;
  var _useFeatureFlagTalonO = useFeatureFlagTalonOne(),
    isTalonOneEnabled = _useFeatureFlagTalonO.isTalonOneEnabled;
  var _useDeliveryLocations = useDeliveryLocations(),
    selectedDeliveryLocation = _useDeliveryLocations.selectedDeliveryLocation;
  var _useUser2 = useUser(),
    user = _useUser2.user,
    defaultShippingAddress = _useUser2.defaultShippingAddress,
    addUserShippingAddress = _useUser2.addShippingAddress,
    setDefaultUserShippingAddress = _useUser2.setDefaultShippingAddress;
  var products = computed(function () {
    var _cart$value$lineItems, _cart$value;
    return (_cart$value$lineItems = (_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.lineItems) !== null && _cart$value$lineItems !== void 0 ? _cart$value$lineItems : [];
  });
  var cartShippingAddress = computed(function () {
    return cart.value.shippingAddress;
  });
  var cartBillingAddress = computed(function () {
    return cart.value.billingAddress;
  });
  var userShippingAddresses = computed(function () {
    var _user$value$shippingA, _user$value;
    return (_user$value$shippingA = (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.shippingAddresses) !== null && _user$value$shippingA !== void 0 ? _user$value$shippingA : [];
  });
  var userShippingAddressesForCurrentCountry = computed(function () {
    return userShippingAddresses.value.filter(function (address) {
      return address.country === config.country;
    });
  });
  var currentShippingAddressId = computed(function () {
    return findCurrentAddressId(userShippingAddressesForCurrentCountry.value, cartShippingAddress.value, fixedCurrentShippingAddressAfterSelectingPickupPoint.value);
  });
  var beforePayLogic = {
    handleSaveNewAddress: function () {
      var _handleSaveNewAddress = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _userShippingAddresse, _cartShippingAddress$, id, __typename, streetNumber, address;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!currentShippingAddressId.value && isAuthenticated.value)) {
                _context.next = 7;
                break;
              }
              _cartShippingAddress$ = cartShippingAddress.value, id = _cartShippingAddress$.id, __typename = _cartShippingAddress$.__typename, streetNumber = _cartShippingAddress$.streetNumber, address = _objectWithoutProperties(_cartShippingAddress$, _excluded);
              _context.next = 4;
              return addUserShippingAddress(address);
            case 4:
              if (!(!defaultShippingAddress.value && (_userShippingAddresse = userShippingAddresses.value[0]) !== null && _userShippingAddresse !== void 0 && _userShippingAddresse.id)) {
                _context.next = 7;
                break;
              }
              _context.next = 7;
              return setDefaultUserShippingAddress(userShippingAddresses.value[0]);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function handleSaveNewAddress() {
        return _handleSaveNewAddress.apply(this, arguments);
      }
      return handleSaveNewAddress;
    }(),
    handleCheckEmptyStreetNumber: function () {
      var _handleCheckEmptyStreetNumber = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _cartShippingAddress$2, _cartBillingAddress$v;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if ((_cartShippingAddress$2 = cartShippingAddress.value) !== null && _cartShippingAddress$2 !== void 0 && _cartShippingAddress$2.streetNumber) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return updateCartShippingAddress(cartShippingAddress.value);
            case 3:
              if ((_cartBillingAddress$v = cartBillingAddress.value) !== null && _cartBillingAddress$v !== void 0 && _cartBillingAddress$v.streetNumber) {
                _context2.next = 6;
                break;
              }
              _context2.next = 6;
              return updateCartBillingAddress(cartBillingAddress.value);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function handleCheckEmptyStreetNumber() {
        return _handleCheckEmptyStreetNumber.apply(this, arguments);
      }
      return handleCheckEmptyStreetNumber;
    }(),
    handleOutOfStockAndDiscontinuedProducts: function () {
      var _handleOutOfStockAndDiscontinuedProducts = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _iterator, _step, product;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(products.value);
              _context3.prev = 1;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context3.next = 10;
                break;
              }
              product = _step.value;
              if (!(isProductOutOfStock(product.variant) || isProductDiscontinued(product.variant))) {
                _context3.next = 8;
                break;
              }
              _context3.next = 8;
              return removeItem({
                product: product
              });
            case 8:
              _context3.next = 3;
              break;
            case 10:
              _context3.next = 15;
              break;
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](1);
              _iterator.e(_context3.t0);
            case 15:
              _context3.prev = 15;
              _iterator.f();
              return _context3.finish(15);
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 12, 15, 18]]);
      }));
      function handleOutOfStockAndDiscontinuedProducts() {
        return _handleOutOfStockAndDiscontinuedProducts.apply(this, arguments);
      }
      return handleOutOfStockAndDiscontinuedProducts;
    }(),
    handleSaveDeliveryLocation: function () {
      var _handleSaveDeliveryLocation = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var location;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              location = selectedDeliveryLocation.value;
              if (!location) {
                _context4.next = 5;
                break;
              }
              fixedCurrentShippingAddressAfterSelectingPickupPoint.value = currentShippingAddressId.value;
              _context4.next = 5;
              return setDeliveryType({
                address: _objectSpread(_objectSpread({}, cartShippingAddress.value), {}, {
                  streetName: [location.address1, location.address2, location.address3].filter(function (adr) {
                    return adr;
                  }).join(' ').trim(),
                  postalCode: location.zipcode,
                  city: location.city,
                  company: [location.carrier, location.nom].filter(function (adr) {
                    return adr;
                  }).join(' ').trim()
                }),
                idRelai: JSON.stringify(location.idRelai),
                carrier: location.carrier,
                serviceType: location.serviceType
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function handleSaveDeliveryLocation() {
        return _handleSaveDeliveryLocation.apply(this, arguments);
      }
      return handleSaveDeliveryLocation;
    }(),
    handleRemoveNotActiveCoupons: function () {
      var _handleRemoveNotActiveCoupons = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var notActiveCoupons, _iterator2, _step2, coupon;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              notActiveCoupons = getAllUnmatchedCoupons(cart.value.discountCodes);
              if (!notActiveCoupons.length) {
                _context5.next = 24;
                break;
              }
              _iterator2 = _createForOfIteratorHelper(notActiveCoupons);
              _context5.prev = 3;
              _iterator2.s();
            case 5:
              if ((_step2 = _iterator2.n()).done) {
                _context5.next = 16;
                break;
              }
              coupon = _step2.value;
              if (!isTalonOneEnabled.value) {
                _context5.next = 12;
                break;
              }
              _context5.next = 10;
              return removeCartCoupon(coupon.discountCode.id);
            case 10:
              _context5.next = 14;
              break;
            case 12:
              _context5.next = 14;
              return legacyRemoveCartCoupon(coupon.discountCode.id);
            case 14:
              _context5.next = 5;
              break;
            case 16:
              _context5.next = 21;
              break;
            case 18:
              _context5.prev = 18;
              _context5.t0 = _context5["catch"](3);
              _iterator2.e(_context5.t0);
            case 21:
              _context5.prev = 21;
              _iterator2.f();
              return _context5.finish(21);
            case 24:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[3, 18, 21, 24]]);
      }));
      function handleRemoveNotActiveCoupons() {
        return _handleRemoveNotActiveCoupons.apply(this, arguments);
      }
      return handleRemoveNotActiveCoupons;
    }()
  };
  return {
    products: products,
    isMalformedCustom: isMalformedCustom,
    handleBeforePay: function () {
      var _handleBeforePay = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var totalBefore, isCartValidForCheckout, redirectToHome;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              totalBefore = '';
              isCartValidForCheckout = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return client.cart.getActiveCart.query();
                      case 2:
                        res = _context6.sent;
                        return _context6.abrupt("return", res.totalLineItemQuantity > 0 && res.version !== undefined);
                      case 4:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function isCartValidForCheckout() {
                  return _ref.apply(this, arguments);
                };
              }();
              redirectToHome = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return router.push(app.localePath({
                          name: 'index'
                        }));
                      case 2:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function redirectToHome() {
                  return _ref2.apply(this, arguments);
                };
              }();
              _context8.next = 5;
              return isCartValidForCheckout();
            case 5:
              if (!_context8.sent) {
                _context8.next = 25;
                break;
              }
              totalBefore = cart.value.totalPrice.centAmount;
              _context8.next = 9;
              return beforePayLogic.handleSaveNewAddress();
            case 9:
              _context8.next = 11;
              return beforePayLogic.handleCheckEmptyStreetNumber();
            case 11:
              _context8.next = 13;
              return beforePayLogic.handleSaveDeliveryLocation();
            case 13:
              _context8.next = 15;
              return updateCartLocaleAndCountry({
                locale: locale,
                country: config.country
              });
            case 15:
              _context8.next = 17;
              return recalculateCart();
            case 17:
              _context8.next = 19;
              return beforePayLogic.handleOutOfStockAndDiscontinuedProducts();
            case 19:
              if (!(products.value.length === 0)) {
                _context8.next = 23;
                break;
              }
              _context8.next = 22;
              return redirectToHome();
            case 22:
              return _context8.abrupt("return");
            case 23:
              _context8.next = 28;
              break;
            case 25:
              _context8.next = 27;
              return redirectToHome();
            case 27:
              return _context8.abrupt("return");
            case 28:
              _context8.next = 30;
              return beforePayLogic.handleRemoveNotActiveCoupons();
            case 30:
              isMalformedCustom.value = totalBefore !== cart.value.totalPrice.centAmount;
            case 31:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function handleBeforePay() {
        return _handleBeforePay.apply(this, arguments);
      }
      return handleBeforePay;
    }()
  };
};
export default useCheckout;